import {useContext, useState, useEffect } from "react";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Icon from "@mui/material/Icon";


import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDProgress from "components/MDProgress";

import breakpoints from "assets/theme/base/breakpoints";

import blank_profile from "assets/images/blank-profile.png";


import { ProfileContext } from "context/profile";

const a11yProps = (index) => {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
};

function Header({name, children = "", tabValue, handleSetTabValue, progress = 0 }) {
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  useEffect(() => {
    // A function that sets the orientation state of the tabs.
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }

    /** 
     The event listener that's calling the handleTabsOrientation function when resizing the window.
    */
    window.addEventListener("resize", handleTabsOrientation);

    // Call the handleTabsOrientation function to set the state with the initial value.
    handleTabsOrientation();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  const { profileImage, setProfileImage } = useContext(ProfileContext);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfileImage({ image: reader.result, purpose: 'profile' });
      };
      reader.readAsDataURL(file);
    }
  };

const handleButtonClick = () => {
    document.getElementById('profile-image-upload').click();
};

  return (
    <MDBox position="relative" mb={5} mt={8}>
      <Card
        sx={{
          position: "relative",
          mt: -8,
          mx: { xs: 0.5, md: 3 },
          py: { xs: 1, md: 2 },
          px: { xs: 1, md: 2 },
        }}
      >
        <Grid container spacing={{ xs: 1, md: 3 }} alignItems="center">

           <Grid item xs={12} md="auto" sx={{ display: "flex", flexDirection: "column", alignItems:"center"}}>
            <MDBox position="relative" display="inline-block">
                <MDAvatar src={profileImage.image ? profileImage.image : blank_profile} alt="profile-image" sx={{ width: 220, height: 220, boxShadow: 6 }} />
                <Icon className="icon-profile"
                    onClick={handleButtonClick} 
          
                >
                    upload
                </Icon>
                <input 
                    id="profile-image-upload" 
                    type="file" 
                    name='image'
                    accept="image/*" 
                    style={{ display: 'none' }} 
                    onChange={handleImageChange} 
                />
              </MDBox>
              <MDBox height="100%" mt={0.5} lineHeight={1}>
              <MDTypography className="profile-name" textAlign="center" variant="h5" fontWeight="medium">
                {name}
              </MDTypography>
            </MDBox>
            <MDBox width="80%" mt={2}>
              <MDTypography variant="caption" fontWeight="bold" color="text" textTransform="uppercase" mb={0.5} display="block" textAlign="center">
                Perfil: {progress}%
              </MDTypography>
              <MDProgress value={progress} color={progress === 100 ? "success" : "info"} variant="gradient" />
            </MDBox>

        </Grid>

          <Grid item xs={12} md={10} lg={8} sx={{ ml: "auto" }}>
            <AppBar position="static">
              <Tabs orientation={tabsOrientation} value={tabValue} onChange={handleSetTabValue}>
                <Tab
                  label="Perfil"
                  {...a11yProps(0)}
                  icon={
                    <Icon fontSize="small" sx={{ mt: -0.25 }}>
                       person
                    </Icon>
                  }
                />
                <Tab
                  label="Informações pessoais"
                  {...a11yProps(1)}
                  icon={
                    <Icon fontSize="small" sx={{ mt: -0.25 }}>
                      manage_accounts
                    </Icon>
                  }
                />
                  <Tab
                    label="Visibilidade"
                    {...a11yProps(2)}
                    icon={
                      <Icon fontSize="small" sx={{ mt: -0.25 }}>
                        remove_red_eye
                      </Icon>
                    }
                  />
                  <Tab
                    label="Segurança"
                    {...a11yProps(3)}
                    icon={
                      <Icon fontSize="small" sx={{ mt: -0.25 }}>
                        admin_panel_settings
                      </Icon>
                    }
                  />
              </Tabs>

            </AppBar>
          </Grid>
        </Grid>
        {children}
      </Card>
    </MDBox>
  );
}

// Typechecking props for the Header
Header.propTypes = {
  children: PropTypes.node,
  name: PropTypes.string.isRequired,
  tabValue: PropTypes.number.isRequired,
  handleSetTabValue: PropTypes.func.isRequired,
  progress: PropTypes.number,
};

export default Header;
